<template>
  <header id="header">
    <nav class="navbar navbar-fixed-top" role="navigation">
      <div class>
        <div class="container-fluid">
          <div class="navbar-header">
            <button class="navbar-toggle">
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <router-link to="/" class="navbar-brand client-logo">
              <img :src="smallLogo" />
            </router-link>
          </div>
          <!--.navbar-header-->

          <div
            class="main-menu"
            v-show="isMainMenuDisplayed && !isReservationStepDisplayed"
          >
            <!-- <ul class="nav nav-pills navbar-nav text-center">
              <li id="nav-airportTrans" class="active product-header">
                <a
                  data-toggle="pill"
                  href="#airportTransfer"
                  @click="onClickAirportTransfer()"
                >
                  <i class="ic-flight-icon"></i>
                  <span>
                    {{ airportLabel }}
                    <span class="sts-brandNew"></span>
                  </span>
                </a>
              </li>
              <li id="nav-carRental" class="product-header">
                <a data-toggle="pill" href="#carSearch" @click="onClickRental()">
                  <i class="ic-car"></i> <span>{{ rentalLabel }}</span>
                </a>
              </li>
            </ul> -->
          </div>

          <!-- <div
            class="other-menu"
            v-show="!isMainMenuDisplayed && !isReservationStepDisplayed"
          >
            <div class="manageSearch">
              <form action>
                <div class="wrapper-search">
                  <i class="ic-search"></i>
                  <input
                    type="text"
                    class="form-control"
                    id="manageInput"
                    placeholder="Type: Jobs ID, Name ( Passenger, Corporate, Provider )"
                    aria-describedby="manageSearch"
                    autocomplete="off"
                  />
                  <div class="advancedOption">
                    <i class="ic-option-up"></i>
                  </div>
                </div>
              </form>
            </div>
          </div> -->

          <div
            class="other-menu navbar-step"
            v-show="!isMainMenuDisplayed && isReservationStepDisplayed"
          >
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="#">
                    <span class="step-number">1</span>
                    Select Car
                  </a>
                </li>
                <li class="breadcrumb-item">
                  <a href="#">
                    <span class="step-number">2</span>
                    Reservation Info
                  </a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  <span class="step-number">3</span>
                  Confirmation
                </li>
              </ol>
            </nav>
          </div>

          <!-- <div class="test-account-label">TEST ACCOUNT</div> -->

          <div
            class="navbar-collapse collapse navbar-data pull-right"
            role="navigation"
          >
            <ul class="nav navbar-nav right-menu pull-right">
              <li class="hidden">
                <router-link to="/*" id="manageBooking">
                  <i
                    class="ic-search"
                    :class="{ isActive: !isMainMenuDisplayed }"
                  ></i>
                </router-link>
              </li>
              <li class="hidden">
                <a>
                  <i
                    class="ic-booking-history"
                    :class="{ isActive: isMainMenuDisplayed }"
                  ></i>
                </a>
              </li>
              <li class="hidden">
                <a>
                  <i
                    class="ic-transaction"
                    :class="{ isActive: isMainMenuDisplayed }"
                  ></i>
                </a>
              </li>
              <li class="hidden">
                <a
                  href="javascript:void(0)"
                  type="button"
                  data-toggle="dropdown"
                >
                  <i class="ic-all-menu"></i>
                </a>
                <ul class="dropdown-menu dropdown-allMenu">
                  <div class="newCaret"></div>
                  <li>
                    <a href="javascript:void(0)">
                      <img :src="cdn + '/images/icon/data-master.svg'" />
                      Invoice
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img
                        :src="cdn + '/images/icon/transactional-report.svg'"
                      />
                      Transactional Report
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img :src="cdn + '/images/icon/setting-hor.svg'" />
                      Imports Form CSV
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img :src="cdn + '/images/icon/setting-hor.svg'" />
                      Imports Group
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img :src="cdn + '/images/icon/wallet.svg'" />
                      Customer Deposit
                    </a>
                  </li>
                </ul>
              </li>
              <li class="hidden">
                <a
                  href="javascript:void(0)"
                  type="button"
                  data-toggle="dropdown"
                >
                  <i class="ic-notification">
                    <span class="sts-listOrder">
                      <div class="pulse"></div>
                      <div class="pulse"></div>
                      <div class="pulse"></div>
                    </span>
                  </i>
                </a>
                <ul class="dropdown-menu dropdown-cartMenu">
                  <div class="newCaret"></div>
                  <div class="emptyList">
                    <img :src="cdn + '/images/icon/No-List.svg'" />
                    <p class="text-center">No Notification</p>
                  </div>
                </ul>
              </li>
              <li class="profile">
                <a
                  href="javascript:void(0)"
                  type="button"
                  data-toggle="dropdown"
                >
                  <span>{{ profileInitial }}</span>
                </a>
                <ul
                  class="dropdown-menu dropdown-profileMenu"
                  role="menu"
                  aria-labelledby="menu1"
                >
                  <div class="newCaret"></div>
                  <li class="head__info-welcome">
                    Hi, {{ profileName }} <span>{{ profileUsername }}</span>
                  </li>
                  <!-- <li class="head__info-profile">
                    PT. Reka Sinergi Pratama
                    <span>Head Office</span>
                  </li> -->
                  <li class="divider"></li>
                  <li class="gotoProduct" v-if="productUrl && productTitle">
                    <a :href="productUrl" target="_blank">
                      <span class="logo-goto"><img :src="opsigoLogo" /></span>
                      Go to {{ productTitle }} <span>Learn more</span>
                    </a>
                  </li>
                  <li class="hidden">
                    <a href="javascript:void(0)">
                      <i class="ic-transactional-report"></i> Your Performance
                    </a>
                  </li>
                  <li class="divider"></li>
                  <li>
                    <router-link to="/profile" id="user-link"
                      >Profile Settings</router-link
                    >
                  </li>
                  <li>
                    <a
                      href="https://support.trransfer.com/"
                      target="_blank"
                      id="user-link"
                      >User Guide</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.trransfer.com/privacypolicy"
                      target="_blank"
                      id="user-link"
                      >Privacy Policy</a
                    >
                  </li>
                  <li>
                    <router-link to="/logout" class="logout"
                      >Log Out</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <!-- multi currency -->
          <div
            class="navbar-collapse collapse navbar-data pull-right"
            role="navigation"
            v-if="!transactionCurrency"
          >
            <ul class="nav navbar-nav right-menu pull-right">
              <li class="profile multi-currency">
                <a
                  href="javascript:void(0)"
                  type="button"
                  data-toggle="dropdown"
                >
                  <span
                    >{{ getSelectedCurrency }}
                    <div class="arrow-dropdown"></div
                  ></span>
                </a>
                <ul
                  class="dropdown-menu dropdown-currency"
                  role="menu"
                  aria-labelledby="menu1"
                >
                  <div class="newCaret"></div>
                  <div class="popular-currencies">
                    Supported currencies <span>(for Credit Card payments)</span>
                  </div>
                  <div class="wrapper-item-currency mt-10">
                    <template v-for="(currency, index) in currencies">
                      <div
                        :class="
                          getSelectedCurrency === currency.value
                            ? 'item-currency active'
                            : 'item-currency'
                        "
                        :key="index"
                        @click="setCurrency(currency.value)"
                      >
                        {{ currency.value }} <span>{{ currency.text }}</span>
                      </div>
                    </template>
                  </div>
                </ul>
              </li>
            </ul>
          </div>

          <!-- multi language -->
          <!-- <div
            class="navbar-collapse collapse navbar-data pull-right"
            role="navigation"
          >
            <ul class="nav navbar-nav right-menu pull-right">
              <li class="profile multi-language">
                <a
                  href="javascript:void(0)"
                  type="button"
                  data-toggle="dropdown"
                >
                  <div class="selected-language">
                    <img
                      src="/static/assets/images/us.svg"
                      alt="selected-langauge"
                      width="25"
                      height="20"
                    />
                    <div class="arrow-dropdown"></div>
                  </div>
                </a>
                <ul
                  class="dropdown-menu dropdown-language"
                  role="menu"
                  aria-labelledby="menu1"
                >
                  <div class="newCaret"></div>
                  <div class="label-select-language">Select your language</div>
                  <div class="wrapper-item-language mt-10">
                    <div class="item-language">
                      <img
                        src="/static/assets/images/us.svg"
                        alt="item-language"
                        width="25"
                        height="15"
                      />
                      <span>English</span>
                    </div>
                    <div class="item-language">
                      <img
                        src="/static/assets/images/hm.svg"
                        alt="item-language"
                        width="25"
                        height="15"
                      />
                      <span>English (Australia)</span>
                    </div>
                    <div class="item-language">
                      <img
                        src="/static/assets/images/sg.svg"
                        alt="item-language"
                        width="25"
                        height="15"
                      />
                      <span>English (Singapore)</span>
                    </div>
                    <div class="item-language">
                      <img
                        src="/static/assets/images/gb.svg"
                        alt="item-language"
                        width="25"
                        height="15"
                      />
                      <span>English (UK)</span>
                    </div>
                    <div class="item-language">
                      <img
                        src="/static/assets/images/my.svg"
                        alt="item-language"
                        width="25"
                        height="15"
                      />
                      <span>Bahasa Melayu</span>
                    </div>
                    <div class="item-language">
                      <img
                        src="/static/assets/images/id.svg"
                        alt="item-language"
                        width="25"
                        height="15"
                      />
                      <span>Bahasa Indonesia</span>
                    </div>
                  </div>
                </ul>
              </li>
            </ul>
          </div> -->
        </div>
        <!--.container-fluid-->
      </div>

      <!--.baru rencana-->
      <!-- <div class="alert mbz alert-info alert-dismissible fade in show" role="alert">
        <div class="container">
          <div class="row text-center">
            <i class="ic-gift mr-10"></i>
            <strong>TGIF! Tonight at 8:00 PM we will update your system, so please don't work at the weekend. Stay Healthy!</strong>
            <button type="button" class="close pull-right mt-5" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>-->
    </nav>
    <!--.navbar-->
  </header>
</template>

<script>
// import { Currencies } from "@/models/constants";
import { UserType } from "@/models/constants";
import lookupService from "@/services/shop/lookup/lookupService.js";

export default {
  computed: {
    transactionCurrency: function () {
      return this.$store.state.setting.transactionCurrency;
    },
    profileInitial: function () {
      if (this.profile) {
        if (this.profile.firstName && this.profile.lastName) {
          return `${this.profile.firstName[0]}${this.profile.lastName[0]}`.toUpperCase();
        } else {
          const profileName = this.profile.firstName.split(" ");
          if (profileName.length > 1) {
            const firstWord = profileName[0];
            const lastWord = profileName[profileName.length - 1];
            return `${firstWord[0]}${lastWord[0]}`.toUpperCase();
          } else {
            return `${this.profile.firstName[0]}${
              this.profile.firstName[this.profile.firstName.length - 1]
            }`.toUpperCase();
          }
        }
      }
      return "";
    },
    profileFirstName: function () {
      return this.profile && this.profile.firstName
        ? this.profile.firstName.charAt(0).toUpperCase() +
            this.profile.firstName.slice(1)
        : "";
    },
    profileLastName: function () {
      return this.profile && this.profile.lastName
        ? this.profile.lastName.charAt(0).toUpperCase() +
            this.profile.lastName.slice(1)
        : "";
    },
    profileName: function () {
      return this.profileFirstName || this.profileLastName
        ? this.profileFirstName + " " + this.profileLastName
        : "";
    },
    profileUsername: function () {
      return this.profile ? this.profile.username : "";
    },
    isMainMenuDisplayed: function () {
      return this.$route.name === "Home";
    },
    isReservationStepDisplayed: function () {
      return this.$route.name === "ReservationForm";
    },
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
    getSelectedCurrency: function () {
      return localStorage.getItem("selectedCurrency") || "SGD";
    },
  },
  data() {
    return {
      rentalLabel: null,
      airportLabel: null,
      smallLogo: null,
      opsigoLogo: null,
      productUrl: null,
      productTitle: null,
      profile: null,
      currencies: [],
      UserType: UserType,
    };
  },
  async created() {
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.profile = await this.$store.dispatch("user/getProfile");
    await this.getSupportedCurrencies();

    this.rentalLabel = this.$helper.extractSetting(
      publicSettings,
      "RentalLabel",
      "Hourly"
    );
    this.airportLabel = this.$helper.extractSetting(
      publicSettings,
      "AirportLabel",
      "Airport Trans"
    );
    this.smallLogo = this.$helper.extractSetting(
      publicSettings,
      "MainLogo",
      `${this.cdn}/images/logo-icon-text.png`
    );
    this.opsigoLogo = this.$helper.extractSetting(
      publicSettings,
      "OpsigoLogo",
      `${this.cdn}/images/small-logo.svg`
    );
    this.productUrl = this.$helper.extractSetting(
      publicSettings,
      "ProductUrl",
      "https://trransfer.com"
    );
    this.productTitle = this.$helper.extractSetting(
      publicSettings,
      "ProductTitle",
      "Trransfer"
    );
  },
  mounted() {
    $(".navbar-toggle")
      .off("click")
      .on("click", function () {
        $(".left-menu").toggleClass("isActive");
        $(".overlay").show();
      });
  },
  methods: {
    async getSupportedCurrencies() {
      const response = await lookupService.supportedCurrencies();

      if (response.isSuccess) {
        this.currencies = response.data.map((curr) => ({
          text: curr.name,
          value: curr.code,
        }));
      }
    },
    onClickRental() {
      // publish message
      this.$eventBus.$emit("navigateToVehicleRental");
    },
    onClickAirportTransfer() {
      // publish message
      this.$eventBus.$emit("navigateToAirportTransfer");
    },
    setCurrency(value) {
      localStorage.setItem("selectedCurrency", value);
      location.reload();
    },
  },
};
</script>
<style scoped>
.active {
  background: #ddd;
}
.popular-currencies {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
}
.popular-currencies span {
  font-style: italic;
  color: #757575;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue